export type MessageViewModel = {
    id: number;
    isInbound: boolean;
    sourceTypeId: number;
    date: string;
    from: string;
    subject: string;
    isRead: boolean;
    isResolved: boolean;
    isAutomatic: boolean;
    customer: string;
    customerId?: number;
    reservationId?: number;

    body: string;
    parentMessageId?: number;
    parentMessage: MessageViewModel;
    messageRecipients: MessageRecipientViewModel[];
    messageAttachments: MessageAttachmentViewModel[];
}

export type MessageRecipientViewModel = {
    to: string;
    isCc: boolean;
    isBcc: boolean;
}

export type MessageAttachmentViewModel = {
    id: number;
    name: string;
    mimeType: string;
    documentId: number;
}

export class NewMessageModel {
    subject = "";
    body = "";
    to = [] as string[];
    attachedDocumentIds = [] as number[];
    sourceTypeId = 0;
    parentMessageId: number | null = null;
    reservationId: number | null = null;
    customerId: number | null = null;
    attachmentsIds = [] as number[];
    notificationTemplateId: number | null = null;
    cultureCode: string | null = null;
}

export type Recipient = {
    id: number;
    type: string;
    name: string;
    email: string;
    telephoneNumber: string;
};

export type AdditionalRecipientModel = {
    type: string;
    name: string;
    email: string;
}

export type ComposedMessage = {
    subject: string;
    body: string;
    recipientsIds: number[];
    additionalRecipients: AdditionalRecipientModel[];
    attachmentDocumentsIds: number[];
}

export enum MessageSourceTypeEnum {
    'BookingCom' = 1,
    'AirBnb' = 2,
    'EMail' = 3,
    'SMS' = 4,
    'WhatsApp' = 5,
    'Liveagent' = 6,
    'TawkTo' = 7,
    'ZenDesk' = 8
}

export enum BaseMessageTypeEnum {
    NewMessage = 1,
    Reply = 2,
    ReplyToAll = 3,
    Forward = 4
}
